import {SocialPlatform} from './';

export enum ChannelStatus {
    NONE = 'NONE', // channel exists, but no longer connected
    VALID = 'VALID', // channel validated
    INVALIDATED = 'INVALIDATED', // Channel exists but no longer connected
    VALIDATING = 'VALIDATING', // channel in process of validation
    INVALID = 'INVALID', // channel oAuthed, but follower count < 1000 || suspended || banned || not public
    ERROR = 'ERROR' // api failed due to lack of permissions from us or user
}

export interface ChannelAuthDetails {
    channelStatus: ChannelStatus;
    authState: string;
    authStateReceived: string;
    impossibleCheck: boolean;
    followers: number;
    valid?: boolean;
}

export interface Channel {
    id?: string;
    link: string;
    channelId: string;
    platform: SocialPlatform;
    mainChannel: boolean;
    oauthDetails: ChannelAuthDetails;
    violations?: string[];
    verifyData?: VerifyData;
    channelStatus?: ChannelStatus;
}

export interface VerifyData {
    error?: Record<string, any> | string | boolean; // error codes or raw string
    isBelonged: boolean;
    isSuspended?: boolean;
    isPublic: boolean;
    followers: number;
    impossibleCheck?: boolean;
    platform: SocialPlatform;
    channelId: string;
}

export interface SocialOptions {
    MINIMUM_FOLLOWERS: number;
    authConfig: {
        [key in SocialPlatform]: {
            CLIENT_ID: string;
            REDIRECT_URL: string;
            CLIENT_SECRET?: string; // NEVER EXPOSE TO CLIENT
        };
    };
}
